import * as React from "react";
import classNames from "classnames";
import {
  CheckboxGroup as UICheckboxGroup,
  CheckboxGroupProps as UICheckboxGroupProps,
} from "@stemscopes/ui";
import { formHooks } from "../../../form/duck";
import styles from "./CheckboxGroup.module.css";

const CheckboxGroup: React.FC<UICheckboxGroupProps> = ({
  name,
  labelClassName,
  children,
  ...rest
}) => {
  const [field] = formHooks.useField<string | string[]>({ name });

  return (
    <UICheckboxGroup
      {...field}
      {...rest}
      name={name}
      labelClassName={classNames(styles.label, labelClassName)}
    >
      {children}
    </UICheckboxGroup>
  );
};

export default CheckboxGroup;
